import api from "@/api";

export async function getAplikacii() {
  const res = await api.get("/aplikacii");
  return res.data;
}